<template>
    <div class="stopCarBox">
        <!--<div class="memberRuleNav">-->
            <!--<i @click="returnFn" class="iconfont iconzuojiantou"></i>-->
        <!--</div>-->
        <div class="scrollBox">
            <div class="scrollContent">
                <div class="imgBox">
                    <img src="../../../assets/img/logo.png"/>
                </div>
                <div class="carPlaceBox">
                    <div class="carPlace">
                        <div class="carPlaceItem">
                            <span class="placeTitel">收费标准</span>
                            <span class="placeCoten1">{{carPark.chargeRuleDesc}}</span>
                        </div>
                        <div class="carPlaceItem">
                            <span class="placeTitel">剩余车位</span>
                            <span class="placeCoten fs">{{carPark.totalRemainNum}}</span>
                        </div>
                        <div class="carPlaceItem">
                            <span class="placeTitel">共有车位</span>
                            <span class="placeCoten fs2">{{carPark.totalNum}}</span>
                        </div>
                    </div>
                </div>
                <div class="carBox">
                    <div class="carItem" index="1" @click="emptyFn(1)">{{province1}}</div>
                    <div class="carItem" index="2" @click="emptyFn(2)">{{province2}}</div>
                    <div class="iconImg">.</div>
                    <div class="carItem" index="3" @click="emptyFn(3)">{{province3}}</div>
                    <div class="carItem" index="4" @click="emptyFn(4)">{{province4}}</div>
                    <div class="carItem" index="5" @click="emptyFn(5)">{{province5}}</div>
                    <div class="carItem" index="6" @click="emptyFn(6)">{{province6}}</div>
                    <div class="carItem" index="7" @click="emptyFn(7)">{{province7}}</div>
                    <div class="carRow"    @click="iptStateFn()" v-if="iptState">新能源</div>
                    <div class="carItem" index="8" @click="emptyFn(8)" v-if="!iptState">{{province8}}</div>
                </div>
                <div class="carTitle">请输入您的车牌号</div>
                <div class="carBox2">
                    <div class="carPal" v-for="(x,index) in plateTest" :key="index" @click="selectCarItemFn(x)">
                        <span style="letter-spacing: 1px;">{{x}}</span>
                        <div class="deleteBten" @click="deleteCarP($event,index)" >
                            <img src="../../../assets/img/wxPay/deleteBtn.svg" />
                        </div>
                    </div>
                </div>
                <div class="btnCar2" v-if="btnState">正在维护</div>
                <div class="btnCar" @click="gotoPayFn" v-else >查缴停车费</div>
                <ul class="rule-box" v-if='ruleList.length'>
                    <h3 class="h3" >一、 收费标准</h3>
                    <li class="li" v-for='item in ruleList' :key='item'><span class="span" >{{item}}</span></li>
                </ul>
                <div class="keyboard" v-show="state1">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataItem" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn1($event)">{{x.name}}</div>
                    </div>
                </div>

                <div class="keyboard" v-show="state2">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataABC" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn2($event)">{{x.name}}</div>
                    </div>
                </div>
                <div class="keyboard" v-show="state3">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataArr" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn3($event)">{{x.name}}</div>
                    </div>
                </div>
                <div class="keyboard" v-show="state4">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataArr" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn4($event)">{{x.name}}</div>
                    </div>
                </div>
                <div class="keyboard" v-show="state5">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataArr" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn5($event)">{{x.name}}</div>
                    </div>
                </div>
                <div class="keyboard" v-show="state6">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataArr" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn6($event)">{{x.name}}</div>
                    </div>
                </div>
                <div class="keyboard" v-show="state7">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataArr" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn7($event)">{{x.name}}</div>
                    </div>
                </div>
                <div class="keyboard" v-show="state8">
                    <div class="xll" @click="Eixt">
                        <img src="../../../assets/img/wxPay/xll.svg"/>
                    </div>
                    <div class="keyboardRow" v-for="(item,index) in dataArr" :key="index">
                        <div class="boardItem" v-for="(x,index) in item" :key="index" @click="provinceFn8($event)">{{x.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "stopCar",
        data(){
          return {
              ruleList:[
                // '1、30分钟以内，免费停车。',
                // '2、0.5-3小时内5元。',
                // '3、3小时以外停车每小时加收1元。',
                // '4、 会员积分支付：100积分=1元。',
                // '4、 请在支付成功后，30分种内离场，否则将重新计费。'
              ],
              iptState: true,
              state1: true,
              state2: false,
              state3: false,
              state4: false,
              state5: false,
              state6: false,
              state7: false,
              state8: false,
              province1:'豫',
              province2:'A',
              province3:'',
              province4:'',
              province5:'',
              province6:'',
              province7:'',
              province8:'',
              carPlateList: ['豫','A'], //车牌
              plateTest: [], //用户存储的车牌
              carPark: "", //车场信息
              btnState:false,
              dataItem:[
                  [{
                      name: '京'
                  },
                      {
                          name: '津'
                      },
                      {
                          name: '渝'
                      },
                      {
                          name: '沪'
                      },
                      {
                          name: '冀'
                      },
                      {
                          name: '晋'
                      },
                      {
                          name: '辽'
                      },
                      {
                          name: '黑'
                      },
                      {
                          name: '苏'
                      }
                  ],
                  [{
                      name: '浙'
                  },
                      {
                          name: '皖'
                      },
                      {
                          name: '闽'
                      },
                      {
                          name: '赣'
                      },
                      {
                          name: '鲁'
                      },
                      {
                          name: '豫'
                      },
                      {
                          name: '鄂'
                      },
                      {
                          name: '湘'
                      },
                      {
                          name: '粤'
                      }
                  ],
                  [{
                      name: '琼'
                  },
                      {
                          name: '川'
                      },
                      {
                          name: '贵'
                      },
                      {
                          name: '云'
                      },
                      {
                          name: '陕'
                      },
                      {
                          name: '甘'
                      },
                      {
                          name: '青'
                      },
                      {
                          name: '蒙'
                      },
                      {
                          name: '桂'
                      }
                  ],
                  [{
                      name: '宁'
                  },
                      {
                          name: '新'
                      },
                      {
                          name: '藏'
                      },
                      {
                          name: '使'
                      },
                      {
                          name: '领'
                      },
                      {
                          name: '警'
                      },
                      {
                          name: '学'
                      },
                      {
                          name: '港'
                      },
                      {
                          name: '澳'
                      }
                  ]
              ],
              dataABC:[
                  [{
                      name: 'A'
                  },
                      {
                          name: 'B'
                      },
                      {
                          name: 'C'
                      },
                      {
                          name: 'D'
                      },
                      {
                          name: 'E'
                      },
                      {
                          name: 'F'
                      },
                      {
                          name: 'G'
                      },
                      {
                          name: 'H'
                      },
                      {
                          name: 'I'
                      }
                  ],
                  [{
                      name: 'J'
                  },
                      {
                          name: 'K'
                      },
                      {
                          name: 'L'
                      },
                      {
                          name: 'M'
                      },
                      {
                          name: 'N'
                      },
                      {
                          name: 'O'
                      },
                      {
                          name: 'P'
                      },
                      {
                          name: 'Q'
                      },
                      {
                          name: 'R'
                      }
                  ],
                  [{
                      name: 'S'
                  },
                      {
                          name: 'T'
                      },
                      {
                          name: 'U'
                      },
                      {
                          name: 'V'
                      },
                      {
                          name: 'W'
                      },
                      {
                          name: 'X'
                      },
                      {
                          name: 'Y'
                      },
                      {
                          name: 'Z'
                      }
                  ]
              ],
              dataArr:[
                  [{
                      name: 'A'
                  },
                      {
                          name: 'B'
                      },
                      {
                          name: 'C'
                      },
                      {
                          name: 'D'
                      },
                      {
                          name: 'E'
                      },
                      {
                          name: '1'
                      },
                      {
                          name: '2'
                      },
                      {
                          name: '3'
                      }
                  ],
                  [{
                      name: 'F'
                  },
                      {
                          name: 'G'
                      },
                      {
                          name: 'H'
                      },
                      {
                          name: 'I'
                      },
                      {
                          name: 'J'
                      },
                      {
                          name: '4'
                      },
                      {
                          name: '5'
                      },
                      {
                          name: '6'
                      }
                  ],
                  [{
                      name: 'K'
                  },
                      {
                          name: 'L'
                      },
                      {
                          name: 'M'
                      },
                      {
                          name: 'N'
                      },
                      {
                          name: 'O'
                      },
                      {
                          name: '7'
                      },
                      {
                          name: '8'
                      },
                      {
                          name: '9'
                      }
                  ],
                  [{
                      name: 'P'
                  },
                      {
                          name: 'Q'
                      },
                      {
                          name: 'R'
                      },
                      {
                          name: 'S'
                      },
                      {
                          name: 'T'
                      },
                      {
                          name: '0'
                      },
                      {
                          name: '港'
                      },
                      {
                          name: '澳'
                      }
                  ],
                  [{
                      name: 'U'
                  },
                      {
                          name: 'V'
                      },
                      {
                          name: 'W'
                      },
                      {
                          name: 'X'
                      },
                      {
                          name: 'Y'
                      },
                      {
                          name: 'Z'
                      },
                      {
                          name: '军'
                      },
                      {
                          name: '领'
                      }
                  ]
              ],
              userData:{},//存储会员数据

          }
        },
        mounted() {
            this.userData = JSON.parse(localStorage.getItem("userData"))//获取会员信息

            document.title = "智能停车"
            let dt = new Date()
            let h = dt.getHours()
            let m = dt.getMinutes()

            if(h == 3 && m < 3){
                this.btnState = true
            }else{
                this.btnState = false
            }

            if(localStorage.getItem('plate') && JSON.parse(localStorage.getItem('plate')).length) {
                this.plateTest = JSON.parse(localStorage.getItem('plate'))
                this.state1 = false
            }

            this.$http.get('/sangto-wrm/vip/park/parkInfo',{
                params:{
                    stationNo: "999997"
                }
            }).then(({data})=>{

                if(data.code == 200 && data.data != null){
                    this.carPark = data.data
                }else{
                    this.Toast.failed(data.message)
                }
            })
            this.$http.get('/sangto-wrm/vip/park/checkstat',{
                params:{
                    vipno:this.userData.cardAccount
                }
            }).then(({data})=>{
                let item = data.data
                if(item.head.length){
                    let P = {}
                    P.carCode = item.head[0].CARCODE //车牌

                    P.parkno = item.head[0].CARPARKFEENO //单号
                    P.payseqno = item.head[0].PAYNUM //交易单序号
                    P.chargeMoney = item.head[0].OWEMONEY*100 //应付金额
                    P.paidMoney = item.head[0].OWEMONEY*100 //代付金额

                    P.inTime = this.toData(item.head[0].CARINTIME)
                    P.JMMoney = item.head[0].JMMONEY
                    P.payTime = this.toData(item.head[0].CARPAYTIME) //缴费时间

                    let itemData = encodeURIComponent(JSON.stringify(P))
                    localStorage.setItem("plateData", JSON.stringify(P)) //存储代付金额

                    this.$router.push({path:'/carPay', query:{'plate':itemData}})
                }
            })
        },
        methods:{

            toData(val){
                var dt = new Date(val)
                var y = dt.getFullYear()
                var m = dt.getMonth() + 1
                var d = dt.getDate()
                var h = dt.getHours()
                var f = dt.getMinutes()
                var s = dt.getSeconds()
                if(m < 10) {
                    m = '0' + m
                }
                if(d < 10) {
                    d = '0' + d
                }
                if(h < 10) {
                    h = '0' + h
                }
                if(f < 10) {
                    f = '0' + f
                }
                if(s < 10) {
                    s = '0' + s
                }
                return y + '-' + m + '-' + d + ' ' + h + ':' + f + ':' + s
            },
            emptyFn(i){
                switch(i) {
                    case 1:
                        this.province1 = '豫'
                        this.state1 = true
                        this.state2 = false
                        this.state3 = false
                        this.state4 = false
                        this.state5 = false
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                        break
                    case 2:
                        this.province2 = 'A'
                        this.state1 = false
                        this.state2 = true
                        this.state3 = false
                        this.state4 = false
                        this.state5 = false
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                        break
                    case 3:
                        this.province3 = ''
                        this.state1 = false
                        this.state2 = false
                        this.state3 = true
                        this.state4 = false
                        this.state5 = false
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                        break
                    case 4:
                        this.province4 = ''
                        this.state1 = false
                        this.state2 = false
                        this.state3 = false
                        this.state4 = true
                        this.state5 = false
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                        break
                    case 5:
                        this.province5 = ''
                        this.state1 = false
                        this.state2 = false
                        this.state3 = false
                        this.state4 = false
                        this.state5 = true
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                        break
                    case 6:
                        this.province6 = ''
                        this.state1 = false
                        this.state2 = false
                        this.state3 = false
                        this.state4 = false
                        this.state5 = false
                        this.state6 = true
                        this.state7 = false
                        this.state8 = false
                        break
                    case 7:
                        this.province7 = ''
                        this.state1 = false
                        this.state2 = false
                        this.state3 = false
                        this.state4 = false
                        this.state5 = false
                        this.state6 = false
                        this.state7 = true
                        this.state8 = false
                        break
                    case 8:
                        this.province8 = ''
                        this.carPlateList = this.carPlateList.slice(0, -1)
                        this.state1 = false
                        this.state2 = false
                        this.state3 = false
                        this.state4 = false
                        this.state5 = false
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                        this.iptState = true
                        break
                }
            },
            Eixt(){//收键盘
                this.state1 = false
                this.state2 = false
                this.state3 = false
                this.state4 = false
                this.state5 = false
                this.state6 = false
                this.state7 = false
                this.state8 = false
            },
            selectCarItemFn(item){//选择存储的车牌
                this.plate = item
                if(item.length == 8) {
                    this.iptState = false
                } else {
                    this.province8 = ''
                    this.iptState = true
                }
                for(let i = 0, len = item.length; i < len; i++) {
                    this["province" + (i + 1)] = item[i]
                }
            },
            gotoPayFn(){ //查缴停车费
                if(this.carPlateList.length >= 7) {
                    this.plate = this.carPlateList.join().replace(/,/g, '')
                }
                this.$http.get('/sangto-wrm/vip/park/parkQuery',{
                    params:{
                        carCode:this.plate, //车牌
                        vipno:this.userData.cardAccount
                    }
                }).then(({data})=>{

                    if(data.data.resCode == 0){
                        // let strData = encodeURIComponent(JSON.stringify(data.data))
                        if(localStorage.getItem("plate")){
                            let arr = JSON.parse(localStorage.getItem("plate"))

                            if(arr.indexOf(this.plate) < 0) {
                                if(arr.length<4){
                                    arr.push(this.plate)
                                }else{
                                    arr.shift()
                                    arr.push(this.plate)
                                }

                            }
                            //
                            localStorage.setItem("plate", JSON.stringify(arr)) //保存车牌
                            localStorage.setItem("plateData", JSON.stringify(data.data))
                            this.$router.push({path:'/carPay'}) //query:{'plate':strData}
                        }else{
                            let arr = []
                            arr.push(this.plate)
                            localStorage.setItem("plate", JSON.stringify(arr))
                            localStorage.setItem("plateData", JSON.stringify(data.data))
                            this.$router.push({path:'/carPay'})
                        }
                    }else{
                        this.UI.Toast.failed("未找到车辆信息")
                        this.province1 = '豫'
                        this.province2 = 'A'
                        this.province3 = ''
                        this.province4 = ''
                        this.province5 = ''
                        this.province6 = ''
                        this.province7 = ''
                        this.province8 = ''
                        this.state1 = true
                        this.state2 = false
                        this.state3 = false
                        this.state4 = false
                        this.state5 = false
                        this.state6 = false
                        this.state7 = false
                        this.state8 = false
                    }
                })
            },
            deleteCarP(e, index){
                e.stopPropagation()
                this.UI.Dialog.confirm({
                    title: '确认',
                    content: '请确认是否删除车牌号',
                    confirmText: '确定',
                    onConfirm: () =>{
                        var arr = JSON.parse(localStorage.getItem('plate'))
                        arr.splice(index, 1)
                        this.plateTest = arr
                        localStorage.setItem('plate', JSON.stringify(arr))
                        this.state1 = true
                    }
                })
            },
            provinceFn1(e){//车牌第一位
                this.carPlateList[0] = ""
                this.carPlateList[0] = e.target.innerText
                this.province1 = e.target.innerText
                this.state1 = false
                this.state2 = true
            },
            provinceFn2(e){//车牌第二位

                this.carPlateList[1] = ""
                this.carPlateList[1] = e.target.innerText
                this.province2 = e.target.innerText
                this.state2 = false
                this.state3 = true
            },
            provinceFn3(e){//车牌第三位
                this.carPlateList[2] = ""
                this.carPlateList[2] = e.target.innerText
                this.province3 = e.target.innerText
                this.state3 = false
                this.state4 = true
            },
            provinceFn4(e){//车牌第四位
                this.carPlateList[3] = ""
                this.carPlateList[3] = e.target.innerText
                this.province4 = e.target.innerText
                this.state4 = false
                this.state5 = true
            },
            provinceFn5(e){//车牌第五位
                this.carPlateList[4] = ""
                this.carPlateList[4] = e.target.innerText
                this.province5 = e.target.innerText
                this.state5 = false
                this.state6 = true
            },
            provinceFn6(e){//车牌第六位
                this.carPlateList[5] = ""
                this.carPlateList[5] = e.target.innerText
                this.province6 = e.target.innerText
                this.state6 = false
                this.state7 = true
            },
            provinceFn7(e){//车牌第七位
                this.carPlateList[6] = ""
                this.carPlateList[6] = e.target.innerText
                this.province7 = e.target.innerText
                this.state7 = false
            },
            provinceFn8(e){//车牌第八位
                this.carPlateList[7] = ""
                this.carPlateList[7] = e.target.innerText
                this.province8 = e.target.innerText
                this.state8 = false
            },
            iptStateFn(){//新能源车牌位
                this.state8 = true
                this.iptState = false
            }
        },

    }
</script>

<style lang="scss" scoped>
.stopCarBox{
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #fff;
    /*.memberRuleNav{*/
        /*width: 100%;*/
        /*height: 45px;*/
        /*background-color: #6cf;*/
        /*box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);*/
        /*line-height: 45px;*/
    /*}*/
    /*.iconzuojiantou{*/
        /*font-size: 24px;*/
        /*color: #fff;*/
        /*margin-left: 4px;*/
        /*padding: 6px;*/
    /*}*/
    .scrollBox{
        position: absolute;
        top: 0px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollContent{
        width: 100%;
        padding-bottom: 40px;
    }
    .ng-scope {
        overflow: hidden;
    }

    .stopCarPay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        font-size: 14px;
    }

    .imgBox {
        width: 50%;
        height: 55px;
        margin:18px auto 0px auto;
    }

    .imgBox img {
        width: 100%;
        height: 100%;
    }

    .carBox {
        width: 90%;
        margin: 40px auto 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .carBox2 {
        width: 90%;
        margin: 10px auto 0 auto;
        display: flex;
        flex-direction: column;

    }

    .iconImg {
        width: 7px;
        height: 36px;
        font-size: 34px;
        text-align: center;
        line-height: 14px;
        color: #888;
    }

    .carItem {
        width: 36px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        border: 1px solid #ccc;
        border-radius: 3px;
    }

    .carRow {
        width: 38px;
        height: 38px;
        font-size: 12px;
        text-align: center;
        border: 1px dashed rgba(77, 149, 6, 0.705);
        line-height: 38px;
        color: rgba(77, 149, 6, 0.705);
    }

    .carTitle {
        margin-top: 6px;
        height: 20px;
        text-align: center;
        font-size: 12px;
        color: #888;
        letter-spacing: 1px;
    }

    .btnCar {
        width: 80%;
        height: 40px;
        background-color: #2db7f5;
        margin: 55px auto 0 auto;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        letter-spacing: 1px;
        border-radius: 4px;
    }
    .btnCar2 {
        width: 80%;
        height: 40px;
        background-color: #ddd;
        margin: 55px auto 0 auto;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        letter-spacing: 1px;
        border-radius: 4px;
    }
    .rule-box{
        padding:20px;
        & .li,& .h3{
            height:30px;
            line-height: 30px;
            margin:auto;
            & .span{
                line-height:20px;
            }
        }
        & .h3{
            font-weight: 900;
        }
    }
    .keyboard {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        min-height: 200px;
        z-index: 1000;
        background-color: #fdfdfd;
        box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.08);
        padding-bottom: 36px;
        padding-top: 12px;
    }

    .keyboardRow {
        display: flex;
        justify-content: space-around;
        padding: 6px;
    }

    .boardItem {
        width: 34px;
        height: 38px;
        border-radius: 3px;
        background-color: #fff;
        box-shadow: 0 1px 4px 0 rgba(80, 53, 53, 0.2);
        color: #666;
        text-align: center;
        line-height: 38px;
        cursor: pointer;
    }

    .carPlace {
        width: 90%;
        height: 60px;
        margin: auto;
        display: flex;
    }

    .carPlaceItem {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .placeTitel {
        font-size: 14px;
        color: #999;
    }

    .placeCoten {
        margin-top: 6px;
        font-size: 18px;

    }

    .placeCoten1 {
        margin-top: 6px;
        font-size: 16px;
        color: #f7a551;
    }

    .carPlaceBox {
        padding-top: 20px;
        border-bottom: 5px solid #f1f1f1;
    }

    .carPal {
        background-color: #ecf5ff;
        display: flex;
        height: 32px;
        padding: 0 10px;
        line-height: 30px;
        font-size: 12px;
        color: #409eff;
        border: 1px solid #d9ecff;
        border-radius: 4px;
        box-sizing: border-box;
        white-space: nowrap;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
    }
    .deleteBten{
        width: 24px;
        height: 28px;
        margin-left: 8px;
        display: flex;
    }
    .deleteBten img{
        margin: auto;
    }
    .tcjl{
        position: absolute;
        right: 3%;
        top:0px;
        padding: 1px 4px;
        font-size: 12px;
        color: #3bcfc0;
    }
    .fs{
        color: #50de90;
    }
    .fs2{
        color: #2db7f5 ;
    }
    .xll{
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 16px;
    }
    .xll img{
        width: 100%;
        height: 100%;
    }
}
</style>
